module.exports = __webpack_public_path__ + "question_38x38.8453db9ea592a3015add7fb268491a3b.png";